// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-1qFuM","arrow":"arrow-1LpZ-"};